import cx from "clsx";
import React from "react";

import PageControlV2 from "../PageProfile/containers/SectionBody/components/PageControlV2";

import SectionBanner from "./containers/SectionBanner";
import SectionHead from "./containers/SectionHead";
import TabAbout from "./containers/TabAbout";
import TabAllArtworks from "./containers/TabAllArtworks";
import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";
import ErrorViewer from "@/modules/kreate-components/components/ErrorViewer";
import { getThumbnailUrlFromBlobId } from "@/modules/kreate-components/components/ImageViewer/utils";
import PageLayout from "@/modules/kreate-components/components/PageLayout";
import { useCollection } from "@/modules/resources/hooks/useCollection";
import { useUser } from "@/modules/resources/hooks/useUser";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collectionId: string;
};

export default function PageCollection({
  className,
  style,
  collectionId,
}: Props) {
  const [collection, collectionError] = useCollection(collectionId);
  const [owner] = useUser(collection?.createdBy);
  const [activeTab, setActiveTab] = React.useState("gallery");

  if (collectionError) {
    return (
      <div className={cx(styles.container, className)} style={style}>
        <ErrorViewer error={collectionError} />
      </div>
    );
  }

  return (
    <div className={cx(styles.container, className)} style={style}>
      <PageLayout
        title={`${collection?.title || EM_DASH} | ${
          owner?.displayName || "Kreate"
        }`}
        description={collection?.description || undefined}
        imageUrl={
          collection?.banner
            ? getThumbnailUrlFromBlobId(collection.banner.blob.blobId)
            : collection?.avatar
            ? getThumbnailUrlFromBlobId(collection.avatar.blob.blobId)
            : undefined
        }
        background="light"
      >
        <SectionBanner banner={collection?.banner} />
        <SectionHead collection={collection} />
        <PageControlV2.Root value={activeTab} onChange={setActiveTab}>
          <PageLayout.Divider />
          <PageLayout.Section>
            <PageControlV2.List
              options={[
                { value: "gallery", label: "Gallery" },
                { value: "about", label: "About" },
              ]}
            />
          </PageLayout.Section>
          <PageLayout.Divider />
          <PageControlV2.Page value="gallery">
            <TabAllArtworks
              collection={collection}
              key={collection?.collectionId}
            />
          </PageControlV2.Page>
          <PageControlV2.Page value="about">
            <PageLayout.Section>
              <TabAbout
                collection={collection}
                key={collection?.collectionId}
              />
            </PageLayout.Section>
          </PageControlV2.Page>
        </PageControlV2.Root>
      </PageLayout>
    </div>
  );
}
